import { useState, useEffect, memo, ComponentProps } from "react";
import GoogleMapReact from "google-map-react";
import { DEFAULT_CENTER, DEFAULT_ZOOM, mapThemes, MAP_THEMES } from "const";
import { GOOGLE_MAPS_LANGUAGE, GOOGLE_MAPS_LIBRARIES } from "utils";

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

type GoogleMapReactProps = ComponentProps<typeof GoogleMapReact>;

export interface IMapProps extends GoogleMapReactProps {
  lat: string | number | undefined;
  lng: string | number | undefined;
  selectedTheme: MAP_THEMES;
  children?: React.ReactNode[] | React.ReactNode;
  innerRef?: React.MutableRefObject<any>;
  shouldUnregisterMapOnUnmount?: boolean;
  zoom?: number;
  debounced?: boolean;
  onZoomAnimationEnd?: (zoomLevel: number) => void;
}

export function Map({
  lat = DEFAULT_CENTER.lat,
  lng = DEFAULT_CENTER.lng,
  zoom = DEFAULT_ZOOM,
  selectedTheme,
  innerRef,
  ...rest
}: IMapProps) {
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    setMapLoaded(true);
  }, []);

  return (
    <div className="h-full w-full">
      {mapLoaded && (
        <GoogleMapReact
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore legacy class component ref typing
          ref={innerRef as any}
          // google-map-react loads the Maps SDK itself from these keys. They
          // must match GOOGLE_MAPS_* in utils/googleMapsLoader.ts exactly —
          // @googlemaps/js-api-loader is a singleton and throws if it is
          // constructed twice with differing options.
          bootstrapURLKeys={{
            key: "" + API_KEY,
            libraries: GOOGLE_MAPS_LIBRARIES,
            language: GOOGLE_MAPS_LANGUAGE,
          }}
          options={{
            styles: mapThemes[selectedTheme],
            fullscreenControl: false,
            minZoom: 2,
          }}
          yesIWantToUseGoogleMapApiInternals
          defaultCenter={DEFAULT_CENTER}
          defaultZoom={DEFAULT_ZOOM}
          center={{ lat: Number(lat), lng: Number(lng) }}
          zoom={zoom}
          {...rest}
        />
      )}
    </div>
  );
}

export default memo(Map);
